<section
    *ngIf="event.overview"
    class="padding-lg list-border"
>
    <h2>{{ 'event overview.About' | translate }}</h2>

    <expandable-content
        seeMoreString="event overview.See more"
        [content]="event.overview"
    >
    </expandable-content>
</section>

<section
    *ngIf="employers.list.length && employers.list.length >= 5"
    class="padding-lg list-border"
>
    <h2>{{ 'event overview.Employers Attending' | translate: { count: employers.total } }}</h2>

    <employers-attending-overview
        [eventId]="event.event_id"
        [employersAttending]="employers.list"
    >
    </employers-attending-overview>
</section>

<section
    *ngIf="!isVirtualFair && event.disable_days !== '1' && regularFairDays.length"
    class="padding-lg list-border"
>
    <h2>{{ 'event overview.When and Where' | translate }}</h2>

    <when-and-where
        parkingString="event overview.Parking Information"
        [isVirtualFair]="isVirtualFair"
        [regularFairDays]="regularFairDays"
        [mapSrc]="event.static_map_url"
        (openParkingInfoModal)="onOpenParkingInfoModal($event)"
    >
    </when-and-where>
</section>

<section
    *ngIf="event.status === 'upcoming' || event.status === 'ongoing'"
    class="padding-xl list-border flexbox flex-column align-items-center badge-default text-center"
>
    <h2 class="space-top-xs space-bottom-xs">
        {{ 'event overview.Dont Miss It' | translate }}
    </h2>
    <p>
        {{ 'event overview.Join us in this unique opportunity to connect students and recruiting employers.' | translate }}
    </p>

    <action-buttons
        styleClass="align-items-center"
        [buttonsData]="actionButtons"
        (buttonClick)="onButtonClick($event)"
    >
    </action-buttons>
</section>
